import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { User, UserDto, PasswordValue, ProfileValue } from '../models';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models/api-response';
import { PasswordValueDto } from '../models/password.value.dto';
import { ProfileValueDto } from '../models/profile.value.dto';

@Service()
export class HttpService {
    private httpClient = inject(HttpClient);

    getProfile(): Observable<User> {
        return this.httpClient.get<ApiResponse<UserDto>>('me').pipe(mapDto((response) => new User(response.data)));
    }

    updateProfile(value: ProfileValue): Observable<User> {
        return this.httpClient.patch<ApiResponse<UserDto>>('me', new ProfileValueDto(value)).pipe(mapDto((response) => new User(response.data)));
    }

    changePassword(value: PasswordValue): Observable<void> {
        const dto = new PasswordValueDto(value);

        return this.httpClient.put<void>('me/password', dto);
    }
}
